import { ApiService } from "./ApiService";

const apiService = new ApiService();

export async function fetchProfile() {
  const response = await apiService.callApi("/api/v1/profile");

  return response.data;
}
